module.exports = __webpack_public_path__ + "static/img/logo.beeb2f71.svg";